import React, { Component } from 'react';

import Header from './components/Header/header';
import Homepage from './components/Homepage/homepage';
import Statements from './components/Statements/statements';
import Results from './components/Results/results';
import jsonConfig from './config.json';  // server url for fetching the environment specific json feed for articles

import './App.css';

class App extends Component {
    constructor() {
        super();
        this.selectIndustry = this.selectIndustry.bind(this);
        this.state = {
            selectedIndustry: '',
            pageId: 'home',
            scrollToTop: true,
            scrollToBottom: false,
        }

        this.showHomePage = this.showHomePage.bind(this);
        this.showStatementsPage = this.showStatementsPage.bind(this);
        this.showResultsPage = this.showResultsPage.bind(this);
    }

    showStatementsPage() {
        this.setState({ pageId:  'statements', scrollToTop: true, scrollToBottom: false });
    }

    showResultsPage(statements) {
        this.setState({ pageId: 'results', statements, scrollToTop: true, scrollToBottom: false });
    }

    showHomePage() {
        this.setState({
            pageId: 'home',
            selectedIndustry: '',
            scrollToTop: true,
            scrollToBottom: false,
        });
    }

    selectIndustry(clickedIndustry) {
        this.setState({ selectedIndustry: clickedIndustry, scrollToTop: false, scrollToBottom: true });
    }

    render() {
        // scroll to top in mobile devices
        if(this.state.scrollToTop){
            window.scrollTo(0, 0);
        }
        if(this.state.scrollToBottom){
            window.scrollTo(0,document.body.scrollHeight);
        }
        return (
            <div className="App">
                <Header jsonConfig={jsonConfig} showHomePage={this.showHomePage} />
                <div className='App-main'>
                    <div className="App-container">
                        {this.state.pageId === 'home' && <Homepage
                                                            industries={this.state.industries}
                                                            selectIndustry={this.selectIndustry}
                                                            selectedIndustry={this.state.selectedIndustry}
                                                            showStatementsPage={this.showStatementsPage}
                                                            jsonConfig={jsonConfig} /> }
                        {this.state.pageId === 'statements' && <Statements onComplete={this.showResultsPage} /> }
                        {this.state.pageId === 'results' && <Results
                                                        statements={this.state.statements}
                                                        jsonConfig={jsonConfig}
                                                        selectedIndustry={this.state.selectedIndustry}
                                                        showHomePage={this.showHomePage} />}
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js